import { render, staticRenderFns } from "./MtrbEditMain.vue?vue&type=template&id=fa4afa1a&scoped=true&"
import script from "./MtrbEditMain.vue?vue&type=script&lang=js&"
export * from "./MtrbEditMain.vue?vue&type=script&lang=js&"
import style0 from "./MtrbEditMain.vue?vue&type=style&index=0&id=fa4afa1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4afa1a",
  null
  
)

export default component.exports